import { useLocation } from "react-router-dom";
import React, { useState, ChangeEvent } from "react";
import AdminHeader from "../../Components/AdminHeader/AdminHeader";
import AdminNav from "../../Components/AdminNav/AdminNav";
import { createGallery } from "../../actions/Galleries";
import { useNavigate } from "react-router-dom";


interface FormData {
    title: string;
    year_posted: string;
    description: string;
    cover_image: File | null;
    gallery_images: File[];
}

function AddGallery() {
    const location = useLocation();
    const user = location.state?.user;
    const [isCollapsed, setIsCollapsed] = useState(true);

    const [formData, setFormData] = useState<FormData>({
        title: '',
        year_posted: '',
        description: '',
        cover_image: null,
        gallery_images: []
    });

    const [coverPreview, setCoverPreview] = useState<string>('');
    const [imagePreviews, setImagePreviews] = useState<string[]>([]);
    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleInputChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleCoverImageUpload = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0];
            setFormData(prev => ({
                ...prev,
                cover_image: file
            }));

            // Revoke previous preview URL if exists
            if (coverPreview) {
                URL.revokeObjectURL(coverPreview);
            }
            setCoverPreview(URL.createObjectURL(file));
        }
    };

    const handleGalleryImageUpload = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.files) {
            const files = Array.from(e.target.files);
            setFormData(prev => ({
                ...prev,
                gallery_images: [...prev.gallery_images, ...files]
            }));

            const newPreviews = files.map(file => URL.createObjectURL(file));
            setImagePreviews(prev => [...prev, ...newPreviews]);
        }
    };

    const removeGalleryImage = (index: number) => {
        setFormData(prev => ({
            ...prev,
            gallery_images: prev.gallery_images.filter((_, i) => i !== index)
        }));

        URL.revokeObjectURL(imagePreviews[index]);
        setImagePreviews(prev => prev.filter((_, i) => i !== index));
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setErrorMessage(null);
        setIsSubmitting(true);

        try {
            const formDataToSend = new FormData();
            formDataToSend.append('title', formData.title);
            formDataToSend.append('year_posted', formData.year_posted);
            formDataToSend.append('description', formData.description);

            if (formData.cover_image) {
                formDataToSend.append('cover_image', formData.cover_image);
            }

            formData.gallery_images.forEach((file, index) => {
                formDataToSend.append(`gallery_images[${index}]`, file);
            });

            const response = await createGallery(formDataToSend);

            if (response.status === 201) {
                // Redirect to galleries list on success
                navigate('/dashboard/galleries/list', {
                    state: {
                        user,
                        successMessage: 'Gallery created successfully'
                    }
                });
            }
        } catch (error: any) {
            setErrorMessage(error.response?.data?.message || 'Error creating gallery');
            console.error('Error creating gallery:', error);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div>
            <AdminHeader isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} user={user} />
            <AdminNav collapsed={isCollapsed} setCollapsed={setIsCollapsed} user={user} />
            <div className={`main-admin-page ${isCollapsed ? 'collapsed' : 'expanded'}`}>
                <div style={{ padding: '20px' }}>
                    <h2>Add New Gallery</h2>

                    {errorMessage && (
                        <div style={{
                            padding: '10px',
                            marginBottom: '20px',
                            backgroundColor: '#ffebee',
                            color: '#c62828',
                            borderRadius: '4px'
                        }}>
                            {errorMessage}
                        </div>
                    )}

                    <form onSubmit={handleSubmit}>
                        {/* Title Field */}
                        <div style={{ marginBottom: '1rem' }}>
                            <input
                                type="text"
                                name="title"
                                value={formData.title}
                                onChange={handleInputChange}
                                placeholder="Title"
                                style={{ width: '100%', padding: '8px' }}
                                required
                            />
                        </div>

                        {/* Date Field */}
                        <div style={{ marginBottom: '1rem' }}>
                            <input
                                type="date"
                                name="year_posted"
                                value={formData.year_posted}
                                onChange={handleInputChange}
                                style={{ width: '100%', padding: '8px' }}
                                required
                            />
                        </div>

                        {/* Description Field */}
                        <div style={{ marginBottom: '1rem' }}>
                            <textarea
                                name="description"
                                value={formData.description}
                                onChange={handleInputChange}
                                placeholder="Description (optional)"
                                style={{
                                    width: '100%',
                                    padding: '8px',
                                    minHeight: '100px',
                                    resize: 'vertical'
                                }}
                            />
                        </div>

                        {/* Cover Image Field */}
                        <div style={{marginBottom: '1rem'}}>
                            <label style={{display: 'block', marginBottom: '8px', fontWeight: 'bold'}}>
                                Cover Image (Required)
                            </label>
                            <input
                                type="file"
                                accept="image/*"
                                onChange={handleCoverImageUpload}

                             required
                        />
                        <div style={{
    maxWidth: '300px',
    border: '1px solid #ddd',
    borderRadius: '4px',
    overflow: 'hidden',
    margin: '10px auto', // Changed this line
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
}}>
    <br />
    <img
        src={coverPreview}
        alt="Cover preview"
        style={{
            width: '100%',
            height: 'auto',
            display: 'block'
        }}
    />
</div>
                        </div>

                        {/* Gallery Images Field */}
<div style={{ marginBottom: '1rem', display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
    <label style={{ marginBottom: '8px', fontWeight: 'bold' }}>
        Gallery Images
    </label>
    <input
        type="file"
        multiple
        accept="image/*"
        onChange={handleGalleryImageUpload}
        style={{ maxWidth: '500px', padding: '8px' }}
    />
</div>

{/* Gallery Images Preview Grid */}
<div style={{
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
    gap: '1rem',
    padding: '1rem 0',
    maxWidth: '2000px',
    margin: '0 auto'
}}>
    {imagePreviews.map((preview, index) => (
        <div key={index} style={{
            position: 'relative',
            aspectRatio: '1',
            border: '1px solid #ddd',
            borderRadius: '4px',
            overflow: 'hidden'
        }}>
            <img
                src={preview}
                alt={`Preview ${index + 1}`}
                style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                }}
            />
            <button
                type="button"
                onClick={() => removeGalleryImage(index)}
                style={{
                    position: 'absolute',
                    top: '5px',
                    right: '5px',
                    background: 'rgba(255, 255, 255, 0.8)',
                    border: 'none',
                    borderRadius: '50%',
                    width: '24px',
                    height: '24px',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#ff4444',
                    fontWeight: 'bold'
                }}
            >
                ✕
            </button>
        </div>
    ))}
</div>

                        {/* Add submit button at the bottom */}
                        <div style={{
    marginTop: '2rem',
    display: 'flex',
    justifyContent: 'center',
    width: '100%'
}}>
                            <button
                                type="button"
                                className="btn btn-info"
                                style={{ width: '10%', display: 'flex', textAlign: "center", alignItems: "center", justifyContent: "center" }}
                                onClick={(e) => handleSubmit(e as any)}
                            >
        {isSubmitting ? 'Creating Gallery...' : 'Create Gallery'}
    </button>
</div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default AddGallery;
